import React, { useState, useEffect } from "react";
import ButtonPrimary from "../button/ButtonPrimary";
import InputSingle from "../input/InputSingle";
import SMSelect from "../select/SMSelect";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";

export default function SMFilterBursa(props) {
  const today = new Date();
  const tomorrow = new Date(today);
  const [resetButton, setresetButton] = useState(false);

  // filter stuff
  const [judul, setjudul] = useState(null);
  const [pemilik, setpemilik] = useState(null);
  const [bentuk, setbentuk] = useState(null);
  const [sifat, setsifat] = useState(null);
  const [tglBuka, settglBuka] = useState(new Date());
  const [tglTutup, settglTutup] = useState(
    tomorrow.setDate(tomorrow.getDate() + 1)
  );

  const ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
      className="example-custom-input bg-gray-200 rounded-lg dark:bg-gray-800 p-2"
      onClick={onClick}
      ref={ref}
    >
      {value}
    </button>
  ));

  function onFilter(params) {
    let filter = "";
    let tgl_buka = tglBuka;
    let tgl_tutup = new Date(tglTutup);

    let b = tgl_buka.toISOString().split("T")[0];
    let t = tgl_tutup.toISOString().split("T")[0];

    // console.log(b, t);

    if (!!judul || !!pemilik) {
      filter = 
      // `filter[user_id]${
      //   !!pemilik ? "=" + pemilik.split(" ").join("+") : ""
      // }
      `filter[judul]${
        !!judul ? "=" + judul.split(" ").join("+") : ""
      }&filter[tanggal_buka]${
        "=" + b 
      }&filter[tanggal_tutup]${
        "=" + t
      }`;

      setresetButton(true);
      props.onSearch(filter);
    } else {
      toast.warn("Setidaknya isi salah satu bidang", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  function onReset() {
    setjudul(null);
    setpemilik(null);
    setbentuk(null);
    setsifat(null);

    props.onReset();
  }
  return (
    <>
      <div className="flex flex-col">
        <p className="text-md my-1">Judul</p>
        <InputSingle
          placeholder="Judul"
          onChange={(e) => {
            setjudul(e.target.value);
          }}
        />
      </div>
      {/* <div className="flex flex-col">
        <p className="text-md my-1">Pemilik</p>
        <InputSingle
          placeholder="e.g schoolmedia"
          onChange={(e) => {
            setpemilik(e.target.value);
          }}
        />
      </div> */}
      <div className="flex flex-col">
        <p className="text-md my-1">Tgl Buka</p>
        <DatePicker
          dateFormat="yyyy-MM-dd"
          selected={tglBuka}
          onChange={(date) => settglBuka(date)}
          selectsStart
          startDate={tglBuka}
          endDate={tglTutup}
          customInput={<ExampleCustomInput />}
        />
      </div>
      <div className="flex flex-col">
        <p className="text-md my-1">Tgl Tutup</p>
        <DatePicker
          dateFormat="yyyy-MM-dd"
          selected={tglTutup}
          onChange={(date) => {
            settglTutup(date);
          }}
          selectsEnd
          startDate={tglBuka}
          minDate={tglBuka}
          endDate={tglTutup}
          customInput={<ExampleCustomInput />}
        />
      </div>

      <div>
        <ToastContainer />
      </div>
      <div className="flex flex-row gap-2">
        {resetButton ? (
          <ButtonPrimary type={"outline"} text="Reset" className="w-full" />
        ) : null}
        <ButtonPrimary
          onClick={() => onFilter()}
          type={"solid"}
          text="Cari"
          className="w-full flex-1"
        />
      </div>
    </>
  );
}
